import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'pdfconvertor_cookie_consent_v1';

const CookieConsent = () => {
    const [choice, setChoice] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY);
        } catch {
            return null;
        }
    });

    useEffect(() => {
        if (choice) {
            try {
                localStorage.setItem(STORAGE_KEY, choice);
            } catch {
                // localStorage may be disabled; fail silently
            }
        }
    }, [choice]);

    if (choice) return null;

    return (
        <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie consent">
            <div className="cookie-consent-inner">
                <div className="cookie-consent-text">
                    <strong>We value your privacy.</strong>{' '}
                    This site uses cookies and similar technologies for site analytics
                    and to serve Google AdSense advertisements. Our advertising partners
                    (including Google) may use cookies to personalize ads based on your
                    prior visits to this and other websites. You can learn more in our{' '}
                    <Link to="/privacy-policy">Privacy Policy</Link>, or opt out of
                    personalized ads at{' '}
                    <a
                        href="https://adssettings.google.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Google Ads Settings
                    </a>.
                </div>
                <div className="cookie-consent-actions">
                    <button
                        type="button"
                        className="btn-link"
                        onClick={() => setChoice('declined')}
                    >
                        Decline
                    </button>
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={() => setChoice('accepted')}
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
